import { Component, OnInit, OnDestroy, HostListener} from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';

interface FunFact {
  number: number;
  desc: string;
  displayedNumber: number;
  duration?: number;
}

interface FunFactTwo {
  number: number;
  title: string;
  desc: string;
  displayedNumber: number;
  duration?: number;
}

export interface Service {
  icon: string;
  title: string;
  desc: string;
}

export interface Team {
  img: string;
  name: string;
  designation: string;
}

export interface SocialMedia {
  icon: string;
}

export interface Work {
  img: string;
  title: string;
  category: string;
}

@Component({
  selector: 'app-home-one',
  templateUrl: './home-one.component.html',
  styleUrl: './home-one.component.css'
})
export class HomeOneComponent implements OnInit, OnDestroy {
    //Header
    isTransparent = true;
    isMenuOpen = false;
    activeDropdown: number | null = null;

    toggleMenu(): void {
      this.isMenuOpen = !this.isMenuOpen;
    }

    toggleDropdown(index: number): void {
      this.activeDropdown = this.activeDropdown === index ? null : index;
    }

    closeMenu(): void {
      this.isMenuOpen = false;
      this.activeDropdown = null;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
      const target = event.target as HTMLElement;
      if (!target.closest('.nav-item') && !target.closest('.header-toggle')) {
        this.activeDropdown = null;
      }
    }

    @HostListener('window:scroll', [])
    onWindowScroll(): void {
      const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      this.isTransparent = offset < 100;
    }
  //Header End

  // OWl Slider
  brandsCarousel: OwlOptions = {
    loop: true,
    dots: false,
    margin:50,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 6,
    navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
  }

  brandStore = [
    {img: "brand-1.png"},
    {img: "brand-2.png"},
    {img: "brand-3.png"},
    {img: "brand-4.png"},
    {img: "brand-5.png"},
    {img: "brand-6.png"}
  ];

  // Portfolio Carousel
  portfolioCarousel:OwlOptions = {
    loop: true,
    dots: true,
    center: true,
    margin:100,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 2,
    navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
  }

  portfolios = [
    {img: "gallery-7.jpg", alt: "Gallery Image 1", title: "Male Model"},
    {img: "gallery-8.jpg", alt: "Gallery Image 2", title: "Female Model"},
    {img: "gallery-9.jpg", alt: "Gallery Image 3", title: "Creative Boy"},
    {img: "gallery-10.jpg", alt: "Gallery Image 4", title: "Fashion Girl"},
  ];

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }
	

  // Funfacts One
  funFacts: FunFact[] = [
    { number: 14, desc: "Experience", displayedNumber: 0, duration: 2000 },
    { number: 800, desc: "Happy Clients", displayedNumber: 0, duration: 3000 },
    { number: 10, desc: "Projects Won", displayedNumber: 0, duration: 2500 }
  ];

  // Funfacts Two
  funFactsTwo: FunFactTwo[] = [
    { number: 111, title: "Projects Won", desc: "Aenean commodo ligula eget dolor. Aenean massa", displayedNumber: 0, duration: 2500 },
    { number: 74, title: "Cups of Coffee", desc: "Aenean commodo ligula eget dolor. Aenean massa", displayedNumber: 0, duration: 2000 },
    { number: 5000, title: "Statisfy Clients", desc: "Aenean commodo ligula eget dolor. Aenean massa", displayedNumber: 0, duration: 3500 },
    { number: 35, title: "Awwwards", desc: "Aenean commodo ligula eget dolor. Aenean massa", displayedNumber: 0, duration: 2200 }
  ];

  private intervals: any[] = [];

  ngOnInit(): void {
    this.startCounters(this.funFacts);
    this.startCounters(this.funFactsTwo);
  }

  // Generic Counter Starter
  startCounters(items: (FunFact | FunFactTwo)[]): void {
    items.forEach(item => this.animateCounter(item));
  }

  // Generic Counter Animation
  animateCounter(item: FunFact | FunFactTwo): void {
    const duration = item.duration ?? 4000;
    const intervalTime = 30;
    const increment = item.number / (duration / intervalTime);

    const interval = setInterval(() => {
      item.displayedNumber = Math.min(item.displayedNumber + increment, item.number);

      if (item.displayedNumber >= item.number) {
        item.displayedNumber = item.number;
        clearInterval(interval);
      }
    }, intervalTime);

    this.intervals.push(interval);
  }

  ngOnDestroy(): void {
    this.intervals.forEach(clearInterval);
  }


  // Services
  services: Service[] = [
    {
      icon: 'bi-globe',
      title: 'Web Development',
      desc: 'Create responsive and modern websites with the latest technologies.'
    },
    {
      icon: 'bi-eyedropper',
      title: 'UI/UX Design',
      desc: 'Design beautiful and intuitive user interfaces that enhance user experience.'
    },
    {
      icon: 'bi-bar-chart',
      title: 'Digital Marketing',
      desc: 'Boost your online presence with effective marketing strategies and campaigns.'
    }
  ];

  // Team
  teams: Team[] = [
    {
      img: 'team-1-sm.jpg',
      name: 'Nicholas Hart',
      designation: 'Web Developer'
    },
    {
      img: 'team-2-sm.jpg',
      name: 'Grace Ross',
      designation: 'Lead Marketing'
    },
    {
      img: 'team-3-sm.jpg',
      name: 'Bobby Castro',
      designation: 'Project Lead'
    },
    {
      img: 'team-4-sm.jpg',
      name: 'Luara Prior',
      designation: 'Data Scientist'
    }
  ];

  socialMedia: SocialMedia[] = [
    { icon: 'bi-facebook' },
    { icon: 'bi-pinterest' },
    { icon: 'bi-twitter-x' }
  ];

  // Works
  works: Work[] = [
    {
      img: 'gallery-1.jpg',
      title: 'Digital Food',
      category: 'Branding'
    },
    {
      img: 'gallery-3.jpg',
      title: 'Poster',
      category: 'Branding'
    },
    {
      img: 'gallery-4.jpg',
      title: 'Blue Berry',
      category: 'Branding'
    },
    {
      img: 'gallery-11.jpg',
      title: 'Death Proof',
      category: 'UI/UX Design'
    },
    {
      img: 'gallery-12.jpg',
      title: '3d Design',
      category: 'Media'
    },
    {
      img: 'gallery-13.jpg',
      title: 'Muse + Metta',
      category: 'Development'
    }
  ];

  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  // EmailJS service configuration
  private serviceId = 'helifax-form';  // Replace with your EmailJS Service ID
  private templateId = 'helifax-form';  // Replace with your EmailJS Template ID
  private publicKey = 'dOfh1ImCGDZCO9GJb';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }
}
